import React from 'react';

import { useIntl } from 'react-intl';

import { ComboSlotType } from 'components/product-detail-v2/product-customization/ComboSlotType';
import { useProductWizardContext } from 'state/product-wizard-v2';
import useProductWizardFlow from 'state/product-wizard-v2/hooks/use-product-wizard-flow';
import { ProductWizardStep } from 'state/product-wizard-v2/types';
import { isCombo } from 'utils/menu';

interface IUseProductDetailHeader {
  headerTitleByProductWizardState: string;
  showCloseButton: boolean;
  showBackArrow: boolean;
}

export const useProductDetailHeader = (
  comboSlotType?: ComboSlotType | null
): IUseProductDetailHeader => {
  const { formatMessage } = useIntl();

  const { isProductReviewFromCart } = useProductWizardFlow();
  const { selectedProduct, menuObject } = useProductWizardContext();
  const { currentStep } = useProductWizardFlow();

  const headerTitleByProductWizardState = React.useMemo(() => {
    switch (currentStep) {
      case ProductWizardStep.ProductCustomization:
        switch (comboSlotType) {
          case ComboSlotType.DRINKS:
            return formatMessage({ id: 'chooseDrink' });
          case ComboSlotType.SIDES:
            return formatMessage({ id: 'chooseSide' });
          case ComboSlotType.PICKER_ASPECT:
            return formatMessage({ id: 'haveItYourWay' });
          default:
            return formatMessage({ id: 'haveItYourWay' });
        }
      case ProductWizardStep.ProductReview:
        return formatMessage({ id: 'reviewYourMeal' });
      default:
        return selectedProduct.name.locale ?? '';
    }
  }, [comboSlotType, currentStep, formatMessage, selectedProduct.name.locale]);

  const showCloseButton = React.useMemo(() => {
    switch (currentStep) {
      case ProductWizardStep.ProductCustomization:
        return !isCombo(menuObject);
      case ProductWizardStep.ProductHome:
        return true;
      case ProductWizardStep.ProductReview:
        return !isProductReviewFromCart;
      default:
        return false;
    }
  }, [currentStep, isProductReviewFromCart, menuObject]);

  const showBackArrow = React.useMemo(() => {
    switch (currentStep) {
      case ProductWizardStep.ProductHome:
        return false;
      default:
        return true;
    }
  }, [currentStep]);

  return {
    headerTitleByProductWizardState,
    showCloseButton,
    showBackArrow,
  };
};
